import { render } from "./WeAreWaterView.vue?vue&type=template&id=11a8f46a"
import script from "./WeAreWaterView.vue?vue&type=script&lang=js"
export * from "./WeAreWaterView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__